module.exports = __webpack_public_path__ + "img/resolve_before_de-ch.2b58a476.svg";